<template>
    <div class="flex">
        <a
            id="saved"
            v-if="saved"
            href="#"
            class="text-transparent transition duration-300 ease-in-out outline-none z-1"
            :class="{
                active: isSaved,
                'article-icon-dark': isDarkTheme(),
                'article-icon-light': isLightTheme(),
            }"
            v-on:click.prevent="toggleSave"
        >
            <svg
                class="h-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 25 31"
                role="img"
                aria-label="Icono para acción de guardar un artículo"
            >
                <path
                    fill="currentColor"
                    stroke-width="2"
                    d="M23.86 29.89h0a.59.59 0 01-.09.32.56.56 0 01-.24.22.55.55 0 01-.28.07h0a.6.6 0 01-.34-.11h0l-10.72-5.1-.22-.1-.22.1-10.23 5.06h0a.63.63 0 01-.3.1.56.56 0 01-.31-.06h0a.6.6 0 01-.25-.22.63.63 0 01-.1-.32V5.54a5 5 0 015-5h13.26a5 5 0 015 5z"
                />
            </svg>
        </a>
        <a
            id="liked"
            v-if="liked"
            href="#"
            class="flex items-center ml-8 text-transparent transition duration-300 ease-in-out outline-none z-1"
            :class="{
                active: isLiked,
                'article-icon-dark': isDarkTheme(),
                'article-icon-light': isLightTheme(),
            }"
            v-on:click.prevent="toggleLike"
        >
            <svg
                class="h-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 34 30"
                role="img"
                aria-label="Icono para acción dar like a un artículo"
            >
                <path
                    fill="currentColor"
                    stroke-width="2"
                    d="M23.695.5h.003c4.874 0 8.879 4.221 8.879 9.496 0 2.265-.916 4.536-2.347 6.699-1.43 2.16-3.353 4.175-5.31 5.919-3.915 3.487-7.912 5.832-8.21 6.002l-.022.012-.02.015a.216.216 0 01-.258 0l-.021-.015-.022-.012c-.295-.168-4.293-2.547-8.21-6.052-1.957-1.752-3.88-3.773-5.31-5.927C1.415 14.481.5 12.227.5 9.997.5 4.72 4.505.5 9.379.5v0h.006c2.6-.033 5.085 1.185 6.76 3.332l.39.503.396-.5C18.617 1.702 21.097.486 23.695.5z"
                />
            </svg>
            <span class="ml-2 text-gray-500">{{ favoritable.likes_count | toLikes }}</span>
        </a>
    </div>
</template>

<script>
import { toLikes } from '../filters';

export default {
    props: {
        favoritable: {
            type: Object,
            required: true,
        },
        liked: {
            type: Boolean,
            default: true,
        },
        path: {
            type: String,
            required: true,
        },
        saved: {
            type: Boolean,
            default: true,
        },
        relation: {
            type: String,
            required: true,
        },
        user: {
            type: Object,
            required: false,
        },
        theme: {
            type: String,
            default: 'dark',
        },
    },

    filters: {
        toLikes,
    },

    data() {
        return {
            isSaved: false,
            isLiked: false,
        };
    },

    mounted() {
        this.isSaved = this.wasSaved();
        this.isLiked = this.wasLiked();
    },

    methods: {
        toggleSave() {
            axios
                .post('/usuario' + this.path + '/' + this.favoritable.slug, {
                    is_saved: !this.isSaved,
                })
                .then(() => {
                    this.isSaved = !this.isSaved;
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        window.location.href = '/mi-cuenta';
                    }
                });
        },

        toggleLike() {
            axios
                .post('/usuario' + this.path + '/' + this.favoritable.slug, {
                    is_liked: !this.isLiked,
                })
                .then(() => {
                    this.isLiked = !this.isLiked;
                    this.isLiked ? (this.favoritable.likes_count += 1) : (this.favoritable.likes_count -= 1);
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        window.location.href = '/mi-cuenta';
                    }
                });
        },

        wasLiked() {
            return (
                this.user[this.relation].filter(
                    (userContent) =>
                        userContent.pivot.is_liked && userContent.pivot.interactable_id === this.favoritable.id
                ).length > 0
            );
        },

        wasSaved() {
            return (
                this.user[this.relation].filter(
                    (userContent) =>
                        userContent.pivot.is_saved && userContent.pivot.interactable_id === this.favoritable.id
                ).length > 0
            );
        },

        isDarkTheme() {
            return this.theme === 'dark';
        },

        isLightTheme() {
            return this.theme === 'light';
        },
    },
};
</script>
